import { render, staticRenderFns } from "./Double.vue?vue&type=template&id=3820e438"
import script from "./Double.vue?vue&type=script&lang=js"
export * from "./Double.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports